import Toast from "./Toast.js?r=21";
import OrderForm from './OrderForm.js?r=75';

const orderForm = new OrderForm(document.getElementById('product-form'));
const inputQuantity = document.querySelector('input[name="quantity"]');
const btnAddToCart = document.querySelector('button.add-to-cart')

document.querySelectorAll('#variant-selector input[type="radio"]').forEach(it => {
  it.addEventListener("change", ev =>{
    const inventory = parseInt(it.dataset['inventory'])
    inputQuantity.setAttribute('max', inventory);
    if(parseInt(inputQuantity.value) > inventory)orderForm.input.value = inventory;
    orderForm.input.update();
    btnAddToCart.classList.remove('disable');
    btnAddToCart.removeAttribute('disabled');
  })
})

//add to wishlist reload
function flushCache(){
  var formData = new FormData();
  formData.append("attributes[cache_time]", Date.now());
  formData.append("attributes[flash]", "");
  
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => console.log(data));
}

const chkWishList = document.getElementById('chk-wishlist');
const btnWishlists = document.querySelectorAll('.btn-wishlist');
const wishCount = document.getElementById('wish-count');
[...btnWishlists].forEach(btnWishlist =>{
  btnWishlist.addEventListener('click', evt => {
    evt.preventDefault();
    
    btnWishlist.classList.add('disabled');
    const btn_action = btnWishlist.getAttribute('data-action')
    switch(btn_action){
      case "add":
      case "remove":
        const url = btnWishlist.getAttribute('href') + '.json?fetch=true';
        const message = btnWishlist.getAttribute('data-flash-message');
        fetch(url).then((res)=>{
          res.json().then(data=>{
            const wishCountValue = parseInt(wishCount.innerText || "0");
            if(data.action === 'wishlist_add'){
              chkWishList.setAttribute('checked', 'checked');
              wishCount.innerHTML = String(wishCountValue + 1)
              wishCount.classList.remove('hidden');
            }else{
              chkWishList.removeAttribute('checked');
              const newWishCount = wishCountValue -1;
              if(newWishCount <= 0){
                wishCount.classList.add('hidden');
              }
              wishCount.innerHTML = String(newWishCount);
            }
            btnWishlist.classList.add('disabled');
            Toast.show(message,  "toast", false);
            flushCache();
          });
        });
        break;
  
      case "login":
        formData.append("attributes[login_return]", window.login_return);
        formData.append("attributes[flash]", "");
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData,
          credentials: "include"
        }).then(()=>{
          window.location = '/account/login';
        });
      default:
        //nothing to do
    }
  
  });
})